// Deterministic "Archive ID" / Case File number generator for the CODEX brand.
// Produces a stable, retro-terminal style code from a topic slug, e.g. "CDX-4F2A-071".

export function archiveId(slug) {
  if (!slug) return "CDX-0000-000";
  const s = String(slug);
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  const hex = h.toString(16).toUpperCase().padStart(8, "0").slice(0, 4);
  const num = (h % 1000).toString().padStart(3, "0");
  return `CDX-${hex}-${num}`;
}
